import * as React from 'react';
import { FilterSelect } from '../FilterSelect';
import { InputLabel } from '../Input/Input';
import { IBLabeledFilterSelectProps } from './LabeledFilterSelect.types';

const LabeledFilterSelect: React.FC<IBLabeledFilterSelectProps> = (
  props: IBLabeledFilterSelectProps
) => {
  const {
    id,
    values,
    onSelect,
    minSearchTextLength,
    searchTimeout,
    className,
    labelClassName,
    label,
    placeholder,
    value,
    testId,
    defaultOptions,
    maxDropdownHeight
  } = props;

  return (
    <div className={`labeled-input ${className ?? ''}`} id={id}>
      {label && (
        <InputLabel className={`${labelClassName ?? ''}`}>{label}</InputLabel>
      )}
      <FilterSelect
        id={`filter-select-${id}`}
        values={values}
        value={value}
        onSelect={onSelect}
        minSearchTextLength={minSearchTextLength}
        searchTimeout={searchTimeout}
        placeholder={placeholder}
        testId={testId}
        defaultOptions={defaultOptions}
        maxDropdownHeight={maxDropdownHeight}
      />
    </div>
  );
};

export default LabeledFilterSelect;
